module.exports = InternalShared('InternalShared/PageBuilder/Controls/Properties/ColorProperty');